import { render, staticRenderFns } from "./addACheckTemplate.vue?vue&type=template&id=20678256&scoped=true&"
import script from "./addACheckTemplate.vue?vue&type=script&lang=ts&"
export * from "./addACheckTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./addACheckTemplate.vue?vue&type=style&index=0&id=20678256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20678256",
  null
  
)

export default component.exports